import {
    Box,
    Grid,
    MenuItem,
    Select,
    TablePagination,
    Typography,
    useTheme,
    Tabs,
    Tab,
    Button, Menu, Divider
} from "@mui/material";
import React, {useEffect, useState, useRef} from "react";
import {DataGrid} from "@mui/x-data-grid";
import AxiosInstance from "../../Common/Api/ApiHelper";
import NoDataImg from "../../Common/NoData";
import Loader from "../../Common/Loader";
import order from "../../Assets/image/dash/Record Circle.png";
import {apiList} from "../../Common/Api/ApiList";
import ErrorToaster from "../../Component/ErrorToaster";
import deleteicon from "../../Assets/image/FAQ/deleteicon.png";
import editIcon from "../../Assets/image/FAQ/Pen.png";
import moment from "moment";
import {toast} from "react-toastify";
import searchicon from "../../Assets/image/dash/Minimalistic Magnifer.png";
import debounce from "lodash.debounce";
import dotLogo from "../../Assets/image/dash/dots.svg";
import {PathList} from "../../Common/Routes/Path";
import {useNavigate} from "react-router-dom";

const PAGE_SIZE_OPTIONS = [30];

export default function PromoCodeScreen() {
    const theme = useTheme();
    const navigate = useNavigate();

    const [user, setUser] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [status, setStatus] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setloading] = useState(false);
    const [page, setPage] = useState(0);
    const [totalData, setTotalData] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
    const [tab, setTab] = useState(0);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [selectedRow, setSelectedRow] = useState(null);

    const searchTermRef = useRef(searchTerm);
    const statusRef = useRef(status);

    const fetchPromoCodeData = async (
        currentStatus,
        currentSearch,
        previousSearch = "",
        previousStatus = 0,
        currentPage = 0,
        pageSize = PAGE_SIZE_OPTIONS[0],
        currentTab = tab
    ) => {
        try {
            setloading(true);
            let newPage = currentPage;

            // Reset to page 0 if search or status changed
            if (currentSearch !== previousSearch || currentStatus !== previousStatus) {
                newPage = 0;
                setPage(0);
            }

            // Build query parameters
            let queryParams = new URLSearchParams();

            if (currentTab === 1) {
                queryParams.append("deleted", "1"); // backend: only deleted
            } else {
                queryParams.append("deleted", "0"); // active only
            }

            // Add pagination parameters (page number starts from 1 in backend)
            queryParams.append("page", (newPage + 1).toString()); // Backend expects 1-based page
            queryParams.append("limit", pageSize.toString());

            // Add search parameter
            if (currentSearch && currentSearch.trim() !== "") {
                queryParams.append("search", currentSearch.trim());
            }

            // Add status filter
            if (currentTab === 0 && currentStatus !== 0) {
                if (currentStatus === 1) queryParams.append("status", "active");
                else if (currentStatus === 2) queryParams.append("status", "inactive");
                else if (currentStatus === 3) queryParams.append("status", "expired");
            }

            // Add sorting (optional)
            queryParams.append("sort_by", "created_at");
            queryParams.append("sort_order", "DESC");

            const api = `${apiList.getPromoCode}?${queryParams.toString()}`;

            // console.log("API Call:", api); // Debug log

            const response = await AxiosInstance.get(api);

            // console.log("Response:", response?.data); // Debug log

            // Map data with row IDs
            const Rowdata = response?.data?.r?.data?.map((data, i) => ({
                ...data,
                id: data?.id || data?._id || `promo-${newPage}-${i}`,
                rowid: newPage * pageSize + i + 1,
            }));

            if (Rowdata && Rowdata.length > 0) {
                setUser(Rowdata);
                setTotalData(response?.data?.r?.pagination?.total_records || 0);
            } else {
                setUser([]);
                setTotalData(0);
            }

            setIsLoading(false);
            setloading(false);
        } catch (error) {
            console.error("Error fetching promo codes:", error);
            ErrorToaster({error});
            setloading(false);
            setIsLoading(false);
            setUser([]);
            setTotalData(0);
        }
    };

    // Debounced search function
    const debouncedFetchUserData = useRef(
        debounce((status, searchTerm, prevSearch, prevStatus, page, rowsPerPage, tab) => {
            fetchPromoCodeData(status, searchTerm, prevSearch, prevStatus, page, rowsPerPage, tab);
        }, 500)
    ).current;

    // Cleanup debounce on unmount
    useEffect(() => {
        return () => {
            debouncedFetchUserData.cancel();
        };
    }, []);

    // Fetch data when dependencies change
    useEffect(() => {
        debouncedFetchUserData(
            status,
            searchTerm,
            searchTermRef.current,
            statusRef.current,
            page,
            rowsPerPage,
            tab
        );

        // Update refs
        searchTermRef.current = searchTerm;
        statusRef.current = status;
    }, [searchTerm, status, page, rowsPerPage, tab]);

    const onStatusChange = (e) => {
        const newStatus = e.target.value;
        setStatus(newStatus);
        setPage(0); // Reset to first page when status changes
    };

    const handlePageChange = (e, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const deletePromoCodeData = async (id) => {
        try {
            if (!window.confirm("Are you sure you want to delete this promo code?")) {
                return;
            }

            const api = `${apiList.deletePromoCode}/${id}`;
            const response = await AxiosInstance.get(api); // Changed to DELETE method

            if (response?.data?.s === 1) {
                toast.success(response.data.m);
                // Refresh data
                fetchPromoCodeData(
                    status,
                    searchTerm,
                    searchTermRef.current,
                    statusRef.current,
                    page,
                    rowsPerPage,
                    tab
                );
            } else if (response?.data?.s === 0) {
                toast.error(response.data.m);
            } else {
                toast.error("Something went wrong please try again...");
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error("Something went wrong please try again...");
        }
    };

    const handleStatusChange = async (id, newStatus) => {
        try {
            const payload = {
                id: id,
                status: newStatus,
            };

            const api = `${apiList.updateStatusPromoCode}`;
            const response = await AxiosInstance.put(api, payload);

            if (response?.data?.s === 1) {
                toast.success(response.data.m);
                // Refresh data
                fetchPromoCodeData(
                    status,
                    searchTerm,
                    searchTermRef.current,
                    statusRef.current,
                    page,
                    rowsPerPage,
                    tab
                );
            } else if (response?.data?.s === 0) {
                toast.error(response.data.m);
            } else {
                toast.error("Something went wrong please try again...");
            }
        } catch (error) {
            console.error("Status change error:", error);
            toast.error("Something went wrong please try again...");
        }
    };

    const restorePromoCode = async (id) => {
        try {
            if (!window.confirm("Restore this promo code?")) return;

            const api = `${apiList.restorePromoCode}/${id}`;
            const response = await AxiosInstance.put(api);

            if (response?.data?.s === 1) {
                toast.success(response.data.m);
                fetchPromoCodeData(
                    status,
                    searchTerm,
                    searchTermRef.current,
                    statusRef.current,
                    page,
                    rowsPerPage,
                    tab
                );
            } else {
                toast.error(response.data.m);
            }
        } catch {
            toast.error("Something went wrong");
        }
    };

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const columns = [
        {
            headerClassName: "super-app-theme--header",
            field: "rowid",
            headerName: "Sr.",
            width: 90,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return params.row.rowid;
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "id",
            headerName: "ID",
            width: 90,
            align: "center",
            headerAlign: "center",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "code",
            headerName: "Promo Code",
            flex: 1,
            minWidth: 150,
            headerAlign: "center",
            align: "center",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "description",
            headerName: "Description",
            type: "text",
            flex: 1,
            minWidth: 250,
            headerAlign: "center",
            align: "left",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "discount_type",
            headerName: "Discount Type",
            width: 130,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return params.row.discount_type === "percentage" ? "Percentage" : "Fixed";
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "discount_value",
            headerName: "Discount Value",
            width: 130,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                const {discount_type, discount_value} = params.row;
                return discount_type === "percentage"
                    ? `${discount_value}%`
                    : `$${discount_value}`;
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "max_discount_amount",
            headerName: "Max Discount",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return params.row.max_discount_amount
                    ? `$${params.row.max_discount_amount}`
                    : "-";
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "min_purchase_amount",
            headerName: "Min Purchase",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return params.row.min_purchase_amount
                    ? `$${params.row.min_purchase_amount}`
                    : "-";
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "usage_limit",
            headerName: "Usage Limit",
            width: 110,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return params.row.usage_limit || "Unlimited";
            },
        },
        {
            headerClassName: "super-app-theme--header",
            field: "usage_count",
            headerName: "Used",
            width: 80,
            headerAlign: "center",
            align: "center",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "per_user_limit",
            headerName: "Per User",
            width: 90,
            headerAlign: "center",
            align: "center",
        },
        {
            headerClassName: "super-app-theme--header",
            field: "valid_from",
            headerName: "Valid From",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: (e) => moment(e?.row?.valid_from).format("MMM DD, YYYY"),
        },
        {
            headerClassName: "super-app-theme--header",
            field: "valid_until",
            headerName: "Valid Until",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: (e) => moment(e?.row?.valid_until).format("MMM DD, YYYY"),
        },
        {
            headerClassName: "super-app-theme--header",
            field: "status",
            headerName: "Status",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                const {id, status} = params.row;

                const getColor = (value) => {
                    if (value === "active") return "green";
                    if (value === "inactive") return "grey";
                    return "red";
                };

                return (
                    <Select
                        value={status}
                        size="small"
                        variant="outlined"
                        onChange={(e) => handleStatusChange(id, e.target.value)}
                        sx={{
                            height: 32,
                            width: 120,
                            fontSize: 14,
                            fontWeight: 500,
                            color: getColor(status),
                            borderRadius: "10px",
                            textAlign: "center",
                            border: `1px solid ${getColor(status)}`,
                            "& .MuiSelect-select": {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "4px 10px",
                            },
                            "& fieldset": {
                                border: "none",
                            },
                        }}
                    >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                        <MenuItem value="expired">Expired</MenuItem>
                    </Select>
                );
            },
        },
        {
            headerClassName: "super-app-theme--header",
            headerName: "Delete",
            sortable: false,
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div>
                            <Button
                                id="basic-button"
                                onClick={(event) => handleMenuClick(event, params.row)}
                            >
                                <img src={dotLogo} alt="" srcSet=""/>
                            </Button>
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleMenuClose}
                            >
                                <MenuItem onClick={() => deletePromoCodeData(selectedRow?.id)}>
                                    <img src={deleteicon} style={{marginRight: "0.5rem"}} alt=""/>{" "}
                                    Delete
                                </MenuItem>
                                {selectedRow?.total_usage === 0 && (
                                    <Box>
                                        <Divider sx={{m: "0 7px"}}/>
                                        <MenuItem
                                            onClick={() => navigate(`${PathList.EditPromoCode}/${selectedRow?.id}`)}
                                            sx={{width: "160px"}}
                                        >
                                            <img src={editIcon} style={{marginRight: "0.5rem"}} alt=""/> Edit
                                        </MenuItem>
                                    </Box>
                                )}
                            </Menu>
                        </div>
                    </Box>
                )
            },
        },
    ];

    const baseColumns = columns.filter(
        (col) => col.headerName !== "Delete" && col.headerName !== "Status"
    );

    const activeColumns = [
        ...baseColumns,
        columns.find((c) => c.headerName === "Status"),
        columns.find((c) => c.headerName === "Delete"),
    ];

    const deletedColumns = [
        ...baseColumns,
        {
            headerClassName: "super-app-theme--header",
            headerName: "Action",
            width: 120,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <Button
                    size="small"
                    variant="contained"
                    color="success"
                    onClick={() => restorePromoCode(params.row.id)}
                >
                    Restore
                </Button>
            ),
        },
    ];

    return (
        <>
            <Box>
                <Tabs
                    value={tab}
                    onChange={(e, newValue) => {
                        setTab(newValue);
                        setPage(0);
                        setStatus(0);
                    }}
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 500,
                            color: "#6b7280", // gray-500 (inactive)
                        },
                        "& .MuiTab-root.Mui-selected": {
                            color: "#2563eb", // blue-600 (VISIBLE)
                            fontWeight: 600,
                        },
                    }}
                >
                    <Tab label="Active Promo Codes"/>
                    <Tab label="Deleted Promo Codes"/>
                </Tabs>
            </Box>

            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: {xs: "column", lg: "row"},
                    justifyContent: "space-between",
                    alignItems: {xs: "start", lg: "end"},
                    gap: "1rem",
                }}
            >

                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        maxWidth: "300px",
                        height: "45px",
                        alignSelf: {xs: "start", lg: "end"},
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search by code, description, values..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: "100%",
                            height: "45px",
                            borderRadius: "10px",
                            fontSize: "14px",
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                            border: "none",
                            outline: "none",
                            paddingLeft: "20px",
                            paddingRight: "45px",
                        }}
                    />
                    <span
                        style={{
                            position: "absolute",
                            right: "15px",
                            top: "10px",
                        }}
                    >
            <img src={searchicon} alt="Search"/>
          </span>
                </Box>

                {/* Filters */}
                <Grid container spacing={2} justifyContent={"end"}>
                    {/* Status Filter */}
                    {tab === 0 && (
                        <Grid item xs={12} sm={4} md={4} lg={2} xl={1.5}>
                            <Box
                                sx={{
                                    padding: "8px",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    boxShadow: "0 3px 10px 0 rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "start",
                                        gap: "0.5rem",
                                        pb: "0.15rem",
                                        color: theme.palette.text.primary,
                                    }}
                                >
                                    <img src={order} height={17} width={17} alt=""/>
                                    Status
                                </Box>

                                <Select
                                    value={status}
                                    fullWidth
                                    sx={{
                                        backgroundColor: "#f5f5f5",
                                        borderRadius: "8px",
                                        ".MuiSelect-select": {
                                            padding: "8px 12px",
                                        },
                                    }}
                                    onChange={onStatusChange}
                                >
                                    {[
                                        {id: 0, status: "All"},
                                        {id: 1, status: "Active"},
                                        {id: 2, status: "Inactive"},
                                        {id: 3, status: "Expired"},
                                    ].map((x, i) => (
                                        <MenuItem key={i} value={x?.id}>
                                            {x?.status}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </Box>

            <Box
                sx={{
                    width: "100%",
                    height: "calc(100vh - 200px)",
                    borderRadius: "5px",
                    mt: 3,
                    p: 2,
                }}
            >
                <Typography sx={{fontSize: "18px", fontWeight: "500", mb: 2}}>
                    Promo Code List {totalData > 0 && `(${totalData} total)`}
                </Typography>

                {isLoading ? (
                    <Loader/>
                ) : (
                    <Box>
                        <DataGrid
                            rows={user}
                            rowCount={totalData}
                            pagination
                            paginationMode="server"
                            disableColumnMenu={true}
                            disableAutosize={true}
                            disableColumnFilter={true}
                            disableRowSelectionOnClick={true}
                            getRowId={(e) => e?.id}
                            hideFooter
                            loading={loading}
                            slots={{noRowsOverlay: NoDataImg}}
                            columns={tab === 0 ? activeColumns : deletedColumns}
                            sx={{
                                display: "flex",
                                cursor: "pointer",
                                justifyContent: "center",
                                ".MuiDataGrid-cell": {textAlign: "center"},
                                ".MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "600",
                                    color: "white",
                                },
                                "& .super-app-theme--header": {
                                    background: theme.palette.primary.Blend,
                                },
                                "& .MuiDataGrid-cell": {
                                    "&:focus": {
                                        outline: "none",
                                    },
                                },
                            }}
                        />
                        <TablePagination
                            component="div"
                            count={totalData}
                            page={page}
                            onPageChange={handlePageChange}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleRowsPerPageChange}
                            rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                        />
                    </Box>
                )}
            </Box>
        </>
    );
}